export default __webpack_public_path__ + "static/media/sports_esports.f4067a6a.svg";